<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="2" />
            <div class="box5">
                <div style="overflow: hidden">
                    <div class="box6" style="float: left">个人信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div style="overflow: hidden">
                        <div class="left_txt" style="margin-top: 30px">用户头像</div>
                        <div style="float: left;border-radius: 50%; overflow: hidden;width: 80px; height: 80px; margin-left: 20px;">
                            <img v-if="obj.avatar" style="width: 100%; height: 100%;" :src="'/api/file/preview/' + obj.avatar" alt="avatar" />
                            <img v-else src="../assets/useer-defaultimg@2x.png" class="user_img" alt="" style="width: 100%; height: 100%;" />
                        </div>
                        <router-link to="/user_info_edit"><div style="float: right; color: #2c9a34;">修改</div></router-link>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">昵称</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;">{{ obj.nickname }}</div>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">用户类型</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;" v-if="obj.userClass == 0">个人用户</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;" v-if="obj.userClass == 1 && obj.userClassName !== ''">企业用户-{{ obj.userClassName }}</div>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">性别</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;" v-if="obj.gender == 0">未知</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;" v-if="obj.gender == 1">男</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;" v-if="obj.gender == 2">女</div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">手机号码</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;">{{ obj.mobile }}</div>
                        <!-- <router-link to="/change_tel"><div class="chang_tel" style="cursor: pointer;">更换手机号</div></router-link> -->
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">姓名</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;">{{ obj.name }}</div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">{{ isSchool ? '证件号码' : '身份证号码' }}</div>
                        <div class="left_txt" style="text-align: left; width: 400px;margin-left: 20px;">{{ obj.idcard }}</div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">{{ isSchool ? '证件照片' : '身份证照片' }}</div>
                        <div style="overflow: hidden; margin-left: 14%">
                            <div style="float: left; overflow: hidden;width: 210px; height: 132px;">
                                <img v-if="obj.idCardImage" :src="'/api/file/preview/' + obj.idCardImage" style="width: 100%; height: 100%;" alt="avatar" />
                            </div>

                            <div style="float: left; overflow: hidden;width: 210px; height: 132px;margin-left: 20px;">
                                <img v-if="obj.idCardImageReverse" :src="'/api/file/preview/' + obj.idCardImageReverse" style="width: 100%; height: 100%;" alt="avatar" />
                            </div>
                        </div>
                    </div>

                    <div style="overflow: hidden;margin-top: 20px;">
                        <div class="left_txt">证件有限期</div>
                        <div class="left_txt" style="width: 400px; text-align: left;margin-left: 20px;">{{ obj.idCardStartTime }} - {{ obj.idCardEndTime }}</div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">地址</div>

                        <div v-if="obj.district" class="left_txt" style="width: 400px; text-align: left;margin-left: 20px;">{{ obj.district.district1 }} - {{ obj.district.district2 }} - {{ obj.district.district3 }}</div>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">详细地址</div>
                        <div class="left_txt" style="width: 400px; text-align: left;margin-left: 20px;">{{ obj.district ? obj.district.districtDetail : '' }}</div>
                    </div>
                    <!-- <div
            style="
              width: 100%;
              height: 1px;
              border: 1px dashed #eeeeee;
              margin-top: 4%;
            "
          ></div> -->
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            all_shi: '', // 下级市
            all_qu: '', // 下级区
            all_available: '', // 所有省份
            obj: {
                avatar: '', //头像
                corpIdCardImage: '', //法人代表身份证图片
                gender: '', //性别: 值为1时是男性，值为2时是女性，值为0时是未知
                idCardImage: '', //身份证照片
                idCardImageReverse: '', //身份证照片反面
                idcard: '', //身份证号
                legalPerson: '', //法定代表人
                licenseImage: '', //营业执照图片
                name: '', //真实姓名
                registrationDate: '', //($date-time)主体注册日期
                subjectName: '', //主体全称
                unifiedSocialCreditCode: '' //统一信用代码
            },
            isSchool: false //判断是否为大专院校
        };
    },
    methods: {
        // 获取地址资源
        get_all_available() {
            this.api.get_all_available().then(res => {
                this.all_available = res.data;
            });
        },
        // 切换地址
        sheng_Change(e) {
            this.obj.province = e;
            this.all_available.forEach(element => {
                if (element.name == e) {
                    this.all_shi = element.children;
                }
            });
        },
        shi_Change(e) {
            this.obj.city = e;
            this.all_shi.forEach(element => {
                if (element.name == e) {
                    this.all_qu = element.children;
                }
            });
        },
        qu_Change(e) {
            this.obj.area = e;
            console.log(this.obj.area);
            this.all_qu.forEach(element => {
                if (element.name == e) {
                    this.all_qu2 = element.children;
                }
            });
        },
        // 头像
        avatar_uploader(e) {
            this.obj.avatar = this.img + e.file.response.data.uuid;
        },

        // 身份证正面
        idCardImage_uploader(e) {
            this.obj.idCardImage = this.img + e.file.response.data.uuid;
        },

        // 身份证反面
        idCardImageReverse_uploader(e) {
            this.obj.idCardImageReverse = this.img + e.file.response.data.uuid;
        },

        // 身份证有效期
        sfz_time_onChange(e) {
            this.obj.idCardStartTime = e[0]._d;
            this.obj.idCardEndTime = e[1]._d;
        },

        // 获取我的信息
        get_user_info() {
            this.api.user_info().then(res => {
                this.obj = res.data;
                if (res.data.company) {
                    this.isSchool = res.data.company.userType == '大专院校科研院所';
                }
            });
        },

        // 保存我的信息
        save_user_info() {
            if (this.obj.name == '' || this.obj.nickname == '' || this.obj.idcard == '') {
            }
            this.api.update_user_info(this.obj).then(res => {
                if (res.ok) {
                    this.$message.success(res.message);
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    },
    created() {
        this.get_user_info();
        this.get_all_available();
    }
};
</script>

<style scoped>
/* ant-upload ant-upload-select ant-upload-select-picture-card */

.ant-upload-select {
    border-radius: 50% !important;
    float: left !important;
}

.save_but {
    width: 100px;
    height: 40px;
    border: 1px solid #2c9a34;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-left: 4%;
    margin-top: 4%;
    cursor: pointer;
}

.ant-upload {
    width: 210px !important;
    height: 132px !important;
}

.chang_tel {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    float: left;
    margin-left: 10px;
    margin-top: 5px;
}

.left_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    width: 10%;
    text-align: right;
    float: left;
    margin-top: 5px;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 989px;
    width: 80%;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.ant-upload {
    width: 210px !important;
    height: 130px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user_info.vue